import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Components
import Sidebar from "./components/Sidebar";
import PrivateRoute from "./components/PrivateRoute";

// Pages
import {
  HomePage,
  SelectItem,
  ProfilePage,
  DetailsPage,
  LoginPage,
  EditProfile,
  MyProfile,
} from "./Pages";
import { useLoginContext } from "./context/Login_context";

function App() {
  const { isLoggedIn, formStatus } = useLoginContext();

  return (
    <BrowserRouter>
      <Sidebar isAuth={isLoggedIn} />

      <Routes>
        {/* --- Public Routes --- */}
        <Route
          path="/"
          element={
            !isLoggedIn ? (
              <LoginPage />
            ) : formStatus ? (
              <Navigate to="/home" />
            ) : (
              <Navigate to="/edit-profile" />
            )
          }
        />

        <Route
          path="/edit-profile"
          element={
            isLoggedIn ? (
              <EditProfile isProfileComplete={formStatus} />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* --- Private Routes (Wrapped in PrivateRoute) --- */}
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <HomePage />
            </PrivateRoute>
          }
        />

        <Route
          path="/selected"
          element={
            <PrivateRoute>
              <SelectItem />
            </PrivateRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />

        <Route
          path="/myprofile"
          element={
            <PrivateRoute>
              <MyProfile />
            </PrivateRoute>
          }
        />

        <Route
          path="/details/:id"
          element={
            <PrivateRoute>
              <DetailsPage />
            </PrivateRoute>
          }
        />

        {/* 404 Redirect */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
